import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const purchaseOrderOpenAtom = createMutationAtomFactory(
  'trade.purchaseOrderOpen',
  (params: { id: string }) => ({
    tradePurchaseOrderOpen: {
      __args: {
        id: params.id,
      },
      id: true,
      status: true,
      documentNumber: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);
